<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-file-powerpoint"
      texto-titulo="Listado de pedidos"
      :to-create-action="{name:'NuevoPedido'}"
      to-create-text="Nuevo pedido"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList
          ref="datatable"
          url="/pedidos/pendientes"
          :fields="fields"
          :rowClick="ver"
          :toPesos="toPesos"
          :toDate="toDate"
          :toDateTime="toDateTime"
        ></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import DataList from "@/components/layouts/DataList";
export default {
  name: "ListarPedidosPendientes",
  components: {
    TituloComponent,
    DataList,
    BlockUI,
  },
  data() {
    return {
      fields: [
        {
          name: "cliente.nombre",
          label: "",
          type: "title",
          class: "",
          append: " - ",
        },
        {
          name: "total",
          label: "",
          type: "title",
          class: "text-danger",
          prepend: "$",
        },
        {
          name: "dia_facturacion",
          label: "Fecha entrega",
          type: "field",
          class: "text-alternate",
        },
        {
          name: "created_at",
          label: "Fecha",
          type: "field",
          class: "",
        },
        {
          name: "estado",
          label: "Estado",
          type: "field",
          class: "text-capitalize text-danger",
        },
        {
          name: "user.nombre",
          label: "Vendedor",
          type: "field",
          class: "",
        },
      ],
      toPesos: ["total"],
      toDate: ["dia_facturacion"],
      toDateTime: ["created_at"],
      loading: false,
    };
  },
  mounted() {},
  methods: {
    ver(pedido) {
      this.$router.push("/comprobantes/nuevo/" + pedido.id);
    },
  },
};
</script>